import { lazy } from "react";
import { Redirect } from "./components/Lead/Redirect";

const FVLookup = lazy(() => import("../looking-glass/components/FVLookup"));
const Lead = lazy(() => import("../looking-glass/components/Lead"));
const Search = lazy(() => import("../looking-glass/components/Search"));

const lookingGlassRoutes = [
  { index: true, element: <Search /> },
  { path: ":id", element: <Redirect /> },
  { path: "fv/:projectId", element: <FVLookup /> },
  { path: ":id/:tabId", element: <Lead /> },
];

export default lookingGlassRoutes;
